import minilluGift from 'assets/minillus-gift.svg'
import minilluDiscount from 'assets/minillus-discount.svg'
import minilluEarth from 'assets/minillus-earth.svg'
import minilluTestimony from 'assets/minillus-testimony.svg'
import miniIlluQuestion from 'assets/minillus-question.svg'
import minilluGoodies from 'assets/minillus-goodies.svg'
import minilluCheck from 'assets/minillus-check.svg'
import logoBlack from 'assets/dift-small-black.svg'
import type { Locales } from '@captaincause/types'
import type { Resources as I18nRessources } from 'i18n'

export type Item = {
  url: string
  locale?: Locales | false
  title: keyof I18nRessources['nav.component']
  description?: keyof I18nRessources['nav.component']
  illustration?: any
  illustrationStyle?: string
}

export const NAV = [
  {
    title: 'solutions',
    items: [
      {
        url: '/cadeau',
        locale: false,
        title: 'dift.dift.title',
        description: 'dift.dift.description',
        illustration: minilluGift,
        illustrationStyle: 'bg-light-purple',
      },
      {
        url: '/loyalty',
        locale: false,
        title: 'dift.integrations.title',
        description: 'dift.integrations.description',
        illustration: minilluDiscount,
        illustrationStyle: 'bg-light-purple',
      },
    ],
  },
  {
    title: 'associations',
    items: [
      {
        url: '/projects',
        title: 'associations.projects.title',
        description: 'associations.projects.description',
        illustration: minilluEarth,
        illustrationStyle: 'bg-light-beige',
      },
      {
        url: '/causes',
        locale: false,
        title: 'associations.selection.title',
        description: 'associations.selection.description',
        illustration: minilluCheck,
        illustrationStyle: 'bg-light-purple',
      },
      {
        url: '/comite-impact',
        title: 'associations.commitee.title',
        description: 'associations.commitee.description',
        illustration: minilluTestimony,
        illustrationStyle: 'bg-light-blue',
      },
    ],
  },
  {
    title: 'resources',
    items: [
      {
        url: '/blog',
        locale: false,
        title: 'resources.blog.title',
        description: 'resources.blog.description',
        illustration: minilluEarth,
        illustrationStyle: 'bg-light-green',
      },
      {
        url: '/testimonials',
        locale: false,
        title: 'resources.testimonials.title',
        description: 'resources.testimonials.description',
        illustration: minilluTestimony,
        illustrationStyle: 'bg-light-purple',
      },
      {
        url: '/no-bullshit',
        locale: false,
        title: 'resources.bullshit.title',
        description: 'resources.bullshit.description',
        illustration: minilluGoodies,
        illustrationStyle: 'bg-light-blue',
      },
    ],
  },
  {
    title: 'about',
    items: [
      {
        url: '/about',
        locale: false,
        title: 'about.who.title',
        description: 'about.who.description',
        illustration: logoBlack,
        illustrationStyle: 'bg-light-purple',
      },
      {
        url: '/faq',
        title: 'about.faq.title',
        description: 'about.faq.description',
        illustration: miniIlluQuestion,
        illustrationStyle: 'bg-light-beige',
      },
    ],
  },
] as const
